import Soundboard from './Soundboard.svelte'
import SoundboardTrial from './SoundboardTrial.svelte'
import ChancesToHitCalculator from './calculators/dnd5e/ChancesToHitCalculator.svelte'
import DiceResultCalculator from './calculators/dnd5e/DiceResultCalculator.svelte'
import SkillCheckChancesCalculator from './calculators/dnd5e/SkillCheckChancesCalculator.svelte'
import SkillCheckCreator from './calculators/dnd5e/SkillCheckCreator.svelte'
import { isDarkTheme } from './store'

const fullSbElement = document.getElementById("Svelte-soundboard")
if (fullSbElement) {
  const app = new Soundboard({
    target: fullSbElement,
  })
}

const trialSbElement = document.getElementById("Svelte-soundboard-trial")
if (trialSbElement) {
  const sceneName = trialSbElement.className
  const app = new SoundboardTrial({
    target: trialSbElement,
    props: {
      sceneName,
    }
  })
}

const calculators = {
  "dnd5e_chances_to_hit": ChancesToHitCalculator,
  "dnd5e_skill_check_dc": SkillCheckChancesCalculator,
  "dnd5e_skill_check_creator": SkillCheckCreator,
  "dice_calculator": DiceResultCalculator,
}
for (const [elementId, clazz] of Object.entries(calculators)) {
  const elem = document.getElementById(elementId)
  if (elem) {
    new clazz({
      target: elem
    })
  }
}

// TODO BL: This comes from layout.js, which at some point we should get rid of in favour of a proper svelte toggle.
// @ts-ignore
subscribeToThemeChanged((newMode) => {
  isDarkTheme.set(newMode == "dark");
})